import { render, staticRenderFns } from "./CustomerLink.vue?vue&type=template&id=74e2bc1a&scoped=true"
import script from "./CustomerLink.vue?vue&type=script&lang=js"
export * from "./CustomerLink.vue?vue&type=script&lang=js"
import style0 from "./CustomerLink.vue?vue&type=style&index=0&id=74e2bc1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e2bc1a",
  null
  
)

export default component.exports